<div mat-dialog-content>
  <ul class="navi navi-hover">
    <li class="navi-header font-weight-bold py-4">
      <span class="font-size-lg">Choose Status:</span>
    </li>
    <li class="navi-separator mb-3 opacity-70"></li>
    <li class="navi-item">
      <a mat-dialog-close (click)="updateStatus('IN_PROGRESS')" class="navi-link">
        <span class="navi-text">
          <span class="label label-xl label-inline label-light-success">In Progress</span>
        </span>
      </a>
    </li>
    <li class="navi-item">
      <a mat-dialog-close (click)="updateStatus('WAITING')" class="navi-link">
        <span class="navi-text">
          <span class="label label-xl label-inline label-light-info">Waiting</span>
        </span>
      </a>
    </li>
    <li class="navi-item">
      <a mat-dialog-close (click)="updateStatus('PLANNED')" class="navi-link">
        <span class="navi-text">
          <span class="label label-xl label-inline label-light-warning">Planned</span>
        </span>
      </a>
    </li>
    <li class="navi-item">
      <a mat-dialog-close (click)="updateStatus('DONE')" class="navi-link">
        <span class="navi-text">
          <span class="label label-xl label-inline label-light-primary">Done</span>
        </span>
      </a>
    </li>
    <li class="navi-item">
      <a mat-dialog-close (click)="updateStatus('ON_HOLD')" class="navi-link">
        <span class="navi-text">
          <span class="label label-xl label-inline label-light-danger">On Hold</span>
        </span>
      </a>
    </li>
  </ul>
</div>
